"use strict";
// Stremio Plus: "Addons" section of the settings, for the owner profile only.
// Exports every addon to a .json file and imports one back (add the missing ones, or replace).
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var components_1 = require("stremio/components");
var common_1 = require("stremio/common");
var core_1 = require("stremio/core");
var components_2 = require("stremio/routes/Settings/components");
var api_1 = __importDefault(require("stremio/plus/api"));
var activeProfile_1 = require("stremio/plus/activeProfile");
var addonsFile_1 = require("stremio/plus/addonsFile");
var AddonsSettings_less_1 = __importDefault(require("./AddonsSettings.less"));
var AddonsSettings = function () {
    var _a;
    var t = (0, react_i18next_1.useTranslation)().t;
    var core = (0, core_1.useCore)();
    var profile = (0, common_1.useProfile)();
    var fileInput = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(null), imported = _b[0], setImported = _b[1];
    var _c = (0, react_1.useState)(false), confirmReplace = _c[0], setConfirmReplace = _c[1];
    var _d = (0, react_1.useState)(false), busy = _d[0], setBusy = _d[1];
    var _e = (0, react_1.useState)(null), message = _e[0], setMessage = _e[1];
    var owner = (0, activeProfile_1.getActiveProfile)();
    var current = (_a = profile.addons) !== null && _a !== void 0 ? _a : [];
    var newCount = imported ? (0, addonsFile_1.mergeAddons)(current, imported).length - current.length : 0;
    var onFile = (0, react_1.useCallback)(function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var file, _a, _b, e_1;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    file = (_c = event.target.files) === null || _c === void 0 ? void 0 : _c[0];
                    event.target.value = '';
                    if (!file)
                        return [2 /*return*/];
                    setConfirmReplace(false);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    _a = setImported;
                    _b = addonsFile_1.parseAddonsBackup;
                    return [4 /*yield*/, file.text()];
                case 2:
                    _a.apply(void 0, [_b.apply(void 0, [_d.sent()])]);
                    setMessage(null);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _d.sent();
                    setImported(null);
                    setMessage({ error: true, text: "".concat(t('PLUS_ADDONS_IMPORT_INVALID'), " (").concat(e_1.message, ")") });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [t]);
    var apply = (0, react_1.useCallback)(function (mode) { return __awaiter(void 0, void 0, void 0, function () {
        var next, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!imported || !profile.auth || !owner)
                        return [2 /*return*/];
                    if (mode === 'replace' && !confirmReplace) {
                        setConfirmReplace(true);
                        return [2 /*return*/];
                    }
                    setBusy(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    next = mode === 'add' ? (0, addonsFile_1.mergeAddons)(current, imported) : (0, addonsFile_1.replaceAddons)(current, imported);
                    return [4 /*yield*/, api_1.default.setAddons(profile.auth.key, owner.token, next)];
                case 2:
                    _a.sent();
                    // The core reloads the collection from the server, like after any addon change.
                    core.transport.dispatch({ action: 'Ctx', args: { action: 'PullAddonsFromAPI' } });
                    setMessage({ error: false, text: t('PLUS_ADDONS_IMPORT_DONE', { count: next.length }) });
                    setImported(null);
                    setConfirmReplace(false);
                    return [3 /*break*/, 5];
                case 3:
                    e_2 = _a.sent();
                    setMessage({ error: true, text: e_2.message });
                    return [3 /*break*/, 5];
                case 4:
                    setBusy(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [imported, profile.auth, owner, confirmReplace, current, core, t]);
    // Only the unlocked owner manages addons.
    if (!(0, activeProfile_1.isUnlocked)(owner) || !(owner === null || owner === void 0 ? void 0 : owner.isMain))
        return null;
    return (react_1.default.createElement(components_2.Section, { label: 'PLUS_ADDONS_SECTION' },
        react_1.default.createElement(components_2.Option, { icon: 'addons-outline', label: 'PLUS_ADDONS_EXPORT' },
            react_1.default.createElement(components_1.Button, { className: 'button', title: t('PLUS_ADDONS_EXPORT'), disabled: current.length === 0, onClick: function () { return (0, addonsFile_1.downloadAddonsBackup)(current); } }, t('PLUS_ADDONS_EXPORT_BUTTON', { count: current.length }))),
        react_1.default.createElement(components_2.Option, { icon: 'local-import', label: 'PLUS_ADDONS_IMPORT' },
            react_1.default.createElement(components_1.Button, { className: 'button', title: t('PLUS_ADDONS_IMPORT'), disabled: busy, onClick: function () { var _a; return (_a = fileInput.current) === null || _a === void 0 ? void 0 : _a.click(); } }, t('PLUS_ADDONS_IMPORT_BUTTON')),
            react_1.default.createElement("input", { ref: fileInput, className: AddonsSettings_less_1.default['file-input'], type: 'file', accept: '.json,application/json', onChange: onFile })),
        imported !== null ?
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: AddonsSettings_less_1.default['summary'] }, t('PLUS_ADDONS_IMPORT_SUMMARY', { count: imported.length, new: newCount })),
                react_1.default.createElement(components_2.Option, { label: 'PLUS_ADDONS_IMPORT_ADD' },
                    react_1.default.createElement(components_1.Button, { className: 'button', disabled: busy || newCount === 0, onClick: function () { return apply('add'); } }, t('PLUS_ADDONS_IMPORT_ADD_BUTTON', { count: newCount }))),
                react_1.default.createElement(components_2.Option, { label: 'PLUS_ADDONS_IMPORT_REPLACE' },
                    react_1.default.createElement(components_1.Button, { className: 'button', disabled: busy, onClick: function () { return apply('replace'); } }, confirmReplace ? t('PLUS_ADDONS_IMPORT_REPLACE_CONFIRM') : t('PLUS_ADDONS_IMPORT_REPLACE_BUTTON'))))
            :
                null,
        message !== null ? react_1.default.createElement("div", { className: message.error ? AddonsSettings_less_1.default['error'] : AddonsSettings_less_1.default['summary'] }, message.text) : null,
        react_1.default.createElement("div", { className: AddonsSettings_less_1.default['hint'] }, t('PLUS_ADDONS_PRIVATE_HINT'))));
};
exports.default = AddonsSettings;
